import React from 'react'
import ReactOnRails from "react-on-rails/client";

import DatePicker from '../admin/layout/DatePicker'
import Feed from '../frontend/Account/Feed'
import SelectBox from '../admin/layout/Select'
import CalendarLayout from './Calendar/CalendarLayout'
import RentalProposalLayout from './RentalProposal/RentalProposalLayout'

ReactOnRails.register({DatePicker, Feed, SelectBox, CalendarLayout, RentalProposalLayout})
